import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { OfferId, offers } from './offers/offerData';
type Props = {
  selectedOffer: OfferId;
};
export function StickyCta({
  selectedOffer
}: Props) {
  const [visible, setVisible] = useState(false);
  const offer = offers[selectedOffer];
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-288" data-mp="3gk5sxsy8mkpg">
      {visible && <motion.div initial={{
      y: 72,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-rosegold/20 bg-white/95 px-3 py-2 backdrop-blur lg:hidden" data-id="element-289" data-mp="3gje739ug01cd">
          <div className="mx-auto flex max-w-md items-center justify-between gap-3" data-id="element-290" data-mp="gyined6dqmrx">
            <div className="leading-tight" data-id="element-291" data-mp="76xeuewlp07b"><p className="text-[9px] text-plum/60 line-through" data-id="element-292" data-mp="765ih1v6iyfz">{offer.originalPrice}</p><p className="font-display text-base font-semibold text-ink" data-id="element-293" data-mp="27ubcyw9r21g">{offer.shortName} {offer.price}</p></div>
            <motion.a whileTap={{
          scale: 0.96
        }} href={offer.checkoutUrl} className="flex items-center gap-1 rounded-full bg-rose px-4 py-2.5 text-[10px] font-semibold uppercase tracking-wider text-white" data-id="element-294" data-mp="gx9x20gy0haa">Comprar <ArrowUpRightIcon className="h-3.5 w-3.5" data-id="element-295" data-mp="pusn5j9g1lt1" /></motion.a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}